import React, { Component } from 'react'
import { prefix } from '../../../i18n';
import { connect } from 'react-redux'
import { withRouter } from 'react-router-dom';
import { CartService, ProductsService } from '../../../services';
import {saveCart, saveCartContacts} from '../../../actions/cartActions';
import {buildTransaction} from '../../../actions/generalActions';
import { saveCampaignUser, saveOrderPayment } from '../../../actions/balanceActions';
import { ToastService } from '../../Gamification2026Template/shared/Toast';
import { ToastContainer } from 'react-toastify';

const tCartCheckout = prefix("cart-checkout")

class ShoppingCartContainer extends Component {
  // Drives the post-submission CartResultModal (success/error states).
  state = {
    cartResult: { show: false, success: false, message: "" }
  }

  payload = (item) => ({
    client_slug: this.props.user.client.slug,
    campaign_slug: this.props.campaign.slug,
    product_id: item.id
  })

  handleReturnToCatalog = () => {
    this.props.history.push('/catalog')
  }

  handleReturnToCart = () => {
    this.props.history.push('/cart')
  }

  handleReturnToAdress = () => {
    this.props.history.push('/cart/address')
  }

  handleSetItemQtt = (item, quantity) => {
    const {
      user,
      campaign
    } = this.props

    const payload = {
      client_slug: this.props.user.client.slug,
      slug: this.props.campaign.slug,
      item_id: item.id,
      quantity: quantity
    }

    this.props.startTransaction(() =>
      CartService.setItemQuantity(payload)
      .then((response) => {
        this.props.saveCart(response.data)
        ToastService.success('Foi definida a quantidade do produto')
      })
      .catch((error) => {
        const message = error.response.data.message || "Impossivel de alterar produto"
        ToastService.error(message)
      })
    );

  }

  handleIncreaseItem = (item) => {
    const {
      user,
      campaign
    } = this.props

    const payload = {
      client_slug: this.props.user.client.slug,
      slug: this.props.campaign.slug,
      item_id: item.id
      }

    this.props.startTransaction(() =>
      CartService.increaseItem(payload)
      .then((response) => {
        this.props.saveCart(response.data)
        ToastService.success('Foi adicionado uma unidade do produto')
      })
      .catch((error) => {
        const message = error.response.data.message || "Impossivel de alterar produto"
        ToastService.error(message)
      })
    );

  }

  handleDecreaseItem = (item) => {
    const payload = {
      client_slug: this.props.user.client.slug,
      slug: this.props.campaign.slug,
      item_id: item.id
      }

    this.props.startTransaction(() =>
      CartService.decreaseItem(payload)
      .then((response) => {
        this.props.saveCart(response.data)
        ToastService.success('Foi removida uma unidade do produto')
      })
      .catch((error) => {
        const message = error.response.data.message || "Impossivel de alterar produto"
        ToastService.error(message)
      })
    )
  }

  handleRemoveItem = (item) => {
    const {
      user,
      campaign
    } = this.props
    const payload = {
      client_slug: this.props.user.client.slug,
      slug: this.props.campaign.slug,
      item_id: item.id
    }
    this.props.startTransaction(() =>
    CartService.removeItem(payload)
    .then((response) => {
      this.props.saveCart(response.data)
      ToastService.success('Produto foi removido')
    })
    .catch((error) => {
      ToastService.error('Impossivel de remover produto')
    }))
  }

  // No endpoint empties the cart in one call, so the items are removed one by
  // one. The server cart is (re)fetched first because flows like the voucher
  // reorder are reachable without ever visiting /cart, which leaves the cached
  // cart stale. The last removal response carries the resulting empty cart.
  clearCart = () => {
    const {
      user,
      campaign
    } = this.props

    const payload = {
      client_slug: user.client.slug,
      slug: campaign.slug
    }

    return CartService.getCart(payload)
      .then((response) => {
        const { cart } = response.data
        const items = (cart && cart.items) || []

        return items.reduce(
          (chain, item) =>
            chain.then(() =>
              CartService.removeItem({ ...payload, item_id: item.id })
            ),
          Promise.resolve()
        )
      })
      .then((response) => {
        if (response) this.props.saveCart(response.data)
        return response
      })
  }

  // `carts/add_item/:item_id` expects the *campaign item* id, not the
  // product id stored on the voucher (voucher_type.product.id) — those are
  // different records, confirmed against the API (product id 404s, the
  // campaign item id for the same product returns 200). The voucher payload
  // doesn't carry the campaign item id directly, so it's looked up by
  // searching the current catalog for an item whose product matches.
  findCatalogItemByProductId = (productId, productName) => {
    const {
      user,
      campaign
    } = this.props

    const payload = {
      client_slug: user.client.slug,
      campaign_slug: campaign.slug,
      text: productName
    }

    return ProductsService.getProducts(payload).then((response) => {
      const items = (response.data && response.data.products) || []
      return items.find(
        (item) => item.product && item.product.id === productId
      )
    })
  }

  // Voucher "Reencomendar": the voucher's product replaces whatever is in the
  // cart, so the cart is emptied before the product is added (one unit, which
  // is all the add_item endpoint supports). The raw promise is returned so the
  // caller's confirmation modal can read the resulting status/message.
  handleReorderProduct = (productId, productName) => {
    const {
      user,
      campaign
    } = this.props

    return this.clearCart()
      .then(() => this.findCatalogItemByProductId(productId, productName))
      .then((catalogItem) => {
        if (!catalogItem) {
          throw new Error("Este produto já não está disponível no catálogo.")
        }

        const payload = {
          client_slug: user.client.slug,
          slug: campaign.slug,
          item_id: catalogItem.id
        }

        return CartService.addItem(payload)
      })
      .then((response) => {
        this.props.saveCart(response.data)
        this.props.history.push('/cart')
        return response
      })
  }

  // A cart is considered "digital only" when every line item is a digital card.
  // Digital-only carts still go through the address step, but as a virtual
  // delivery (see `isVirtual` prop passed to CartAddresses/NewAddressForm),
  // since no physical shipment is required.
  allDigitalCards = () => {
    const { cart } = this.props
    return (
      cart.items.length > 0 &&
      cart.items.every((item) => item.product.is_a_card === true)
    )
  }

  handleCheckCartItems = () => {
    const {
      user,
      campaign
    } = this.props

    const payload = {
      client_slug: user.client.slug,
      slug: campaign.slug
    }

    const nextStep = '/cart/address'

    this.props.startTransaction(() =>
    CartService.checkCartItems(payload)
      .then((response) => {
        this.props.history.push(nextStep)
      })
      .catch((error) => {
        ToastService.error('Carrinho vazio')
      }))
  }

  handleCheckout = ({ 
    shouldUseCoPayment = false,
    acceptCoPaymentConditions = false,
    selectedPaymentMethod = null }) => {
    
    const {
      user,
      campaign,
      cart: { allows_co_payments }
    } = this.props

    const payload = {
      client_slug: user.client.slug,
      slug: campaign.slug,
      co_payment: allows_co_payments && shouldUseCoPayment ? {
        use_co_payment: shouldUseCoPayment,
        accepted_payment_terms: acceptCoPaymentConditions,
        payment_method_id: selectedPaymentMethod.id
      } : null
    }

    this.props.startTransaction(() =>
      CartService.CartCheckout(payload)
        .then((response) => {
          this.props.saveCampaignUser(response.data);
          this.setState({
            cartResult: {
              show: true,
              success: true,
              message: (response.data && response.data.message) || tCartCheckout("checkout-successfully")
            }
          });
        })
        .catch((error) => {
          this.setState({
            cartResult: {
              show: true,
              success: false,
              message: (error.response && error.response.data && error.response.data.error) || tCartCheckout("checkout-error")
            }
          });
      })
    );
  }

  // Success → clear the now-purchased cart and navigate home; error → simply
  // dismiss the modal (the cart still holds the items the user needs to fix).
  handleResultOk = () => {
    const { cartResult } = this.state
    this.setState({ cartResult: { show: false, success: false, message: "" } })
    if (cartResult.success) {
      this.props.saveCart({ cart: { items: [], shipment_address: undefined } })
      this.props.history.push('/')
    }
  }

  handleUpdateAddress = (option) => {
    
    const {
      user,
      campaign
    } = this.props

    const payload = {
      client_slug: user.client.slug, 
      slug: campaign.slug, 
      address_id : option.id
    }
    
    this.props.startTransaction(() => 
      CartService.updateShipmentAddress(payload)
        .then((response) => {
          this.props.saveCart(response.data)
          ToastService.success('Endereço alterado')
        })
        .catch((error) => {
          this.props.saveCart({
            cart: {
              ...this.props.cart,
              shipment_address: undefined
            }
          })
          ToastService.error('Impossivel de associar endereço')
        })
  )}

  handleSaveContacts = (contacts) => {
    this.props.saveCartContacts(contacts)
    this.props.history.push('/cart/checkout')
  }

  handleCheckCartAddress = () =>{

    const {
      user,
      campaign
    } = this.props

    const payload = {
      client_slug: user.client.slug, 
      slug: campaign.slug
    }

    // Digital-only carts still collect the delivery contacts after the
    // (virtual) address step, before reaching the checkout summary.
    const nextStep = this.allDigitalCards() ? '/cart/contacts' : '/cart/checkout'

    this.props.startTransaction(() =>
    CartService.checkCartAddress(payload)
      .then((response) => {
        this.props.history.push(nextStep)
      })
      .catch((error) => {
        ToastService.error('Endereço  associado')
    }));
  }


  fetchCart = () => {
    const {
      user,
      campaign
    } = this.props

    const payload = {
      client_slug: user.client.slug,
      slug: campaign.slug
    }

    CartService.getCart(payload)
    .then((response) => {
      this.props.saveCart(response.data)
      
    })
  }

  userCheckoutRestrictions = ( user_points, cart_total_points, maximum_percentage ) => {
    const userHasNoPoints = user_points == 0 
    const debtPoints = user_points < cart_total_points ? cart_total_points - user_points : 0;
    const restingPoints = cart_total_points * (maximum_percentage / 100) - debtPoints;

    const overcomeMaxPercentage = restingPoints < 0;
    const hasEnoughPoints = debtPoints <= 0;

    return {
      userHasNoPoints,
      hasEnoughPoints,
      overcomeMaxPercentage,
      restingPoints,
      debtPoints,
    };
  };

  render() {
    const {
      component: Component,
      ...rest
    } = this.props;

    return (
      <>
      <Component {...rest}
        fetchCart={this.fetchCart}
        onCheckCartItem={this.handleCheckCartItems}
        onSetItemQuantity={this.handleSetItemQtt}
        onIncreaseItem={this.handleIncreaseItem}
        onDecreaseItem={this.handleDecreaseItem}
        onRemoveItem={this.handleRemoveItem}
        clearCart={this.clearCart}
        onReorderProduct={this.handleReorderProduct}
        onReturnToCatalog={this.handleReturnToCatalog}
        onReturnToCart={this.handleReturnToCart}
        onReturnToAddress={this.handleReturnToAdress}
        onCheckout={this.handleCheckout}
        onUpdateAddress={this.handleUpdateAddress}
        onCheckAddresses={this.handleCheckCartAddress}
        onSaveContacts={this.handleSaveContacts}
        getUserCheckoutRestrictions={this.userCheckoutRestrictions}
        allDigitalCards={this.allDigitalCards()}
        cartResult={this.state.cartResult}
        onResultOk={this.handleResultOk}
      />
      </>
     );
  }
}

const mapStateToProps = (state) => ({
  cart: state.cartReducer.cart,
  user: state.userReducer.user,
  campaign: state.campaignReducer.campaign,
  campaignUser: state.balanceReducer.campaignUser,
  walletConfig: state.walletReducer.config,
});

const mapDispatchToProps = (dispatch) => ({
  saveCart: (cart) => {
    dispatch(saveCart(cart))
  },
  saveCartContacts: (contacts) => {
    dispatch(saveCartContacts(contacts))
  },
  saveCampaignUser: (user) => {
    dispatch(saveCampaignUser(user))
  },
  saveOrderPayment: (orderPayment) => {
    dispatch(saveOrderPayment(orderPayment))
  },
  startTransaction: buildTransaction (dispatch)
})

const Container = withRouter(connect(mapStateToProps, mapDispatchToProps)(ShoppingCartContainer))

export function withShoppingCartContainer(component) {
  return (props) => (
    <Container
      component={component}
      {...props}
    />
  )
}


export default Container;
